import type { SVGProps } from 'react';
const DawnFlagCEU = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CEU_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CEU_svg__a)">
      <path fill="#19BFBF" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m13.381 14.158-.755-.769a.3.3 0 0 1-.079-.13l-.44-1.345a.262.262 0 0 0-.503.144l.4 1.628a.33.33 0 0 1-.086.313l-.156.159a.333.333 0 0 1-.476 0l-.19-.194A.33.33 0 0 1 11 13.73v-.853a.33.33 0 0 0-.034-.147l-.398-.81a.33.33 0 0 0-.3-.187H8.986a.33.33 0 0 0-.151.037l-.854.434a.33.33 0 0 0-.166.194l-.438 1.338a.33.33 0 0 1-.165.193l-.774.394a.33.33 0 0 1-.302 0l-.715-.364a.33.33 0 0 1-.182-.297v-1.595c0-.184.15-.334.334-.334h.904c.184 0 .334-.149.334-.333v-.68q0-.053.016-.104l.432-1.32a.33.33 0 0 1 .317-.23h.726a.33.33 0 0 0 .151-.036l.905-.46a.33.33 0 0 1 .152-.037h.634c.184 0 .333-.149.333-.333v-.064c0-.087.035-.171.096-.233l.099-.1a.333.333 0 0 1 .537.086l.224.458a.33.33 0 0 0 .3.186h1.122a.33.33 0 0 0 .317-.23l.373-1.14a.33.33 0 0 1 .317-.23h.54a.267.267 0 1 0 0-.533h-.448a.333.333 0 0 1-.334-.333V5.41q0-.077.034-.147l.386-.785a.33.33 0 0 0-.062-.38l-.12-.124a.333.333 0 0 0-.476 0l-.714.728a.33.33 0 0 0-.095.233v.877q0 .054-.017.104l-.432 1.32a.33.33 0 0 1-.317.23h-.142a.33.33 0 0 1-.238-.1l-.35-.357A.26.26 0 0 1 11 6.826a.26.26 0 0 0-.38-.233l-.45.23a.33.33 0 0 1-.389-.064l-.257-.262a.33.33 0 0 1-.095-.233V5.47c0-.088.034-.172.095-.234l.952-.97 1.516-1.543a.33.33 0 0 1 .13-.082l1.445-.49a.3.3 0 0 1 .107-.018h.785c.127 0 .243.073.3.187l.397.81a.3.3 0 0 1 .035.147v1.387c0 .087.034.17.095.233l.286.292a.33.33 0 0 1 .08.337l-.383 1.169a.33.33 0 0 0 .13.38L16.761 8l.716.365c.177.09.237.313.128.48l-.79 1.205a.33.33 0 0 0-.054.183v1.261c0 .143-.09.27-.226.316l-1.214.412a.33.33 0 0 0-.192.169l-.44.894a.3.3 0 0 1-.06.087l-.773.786a.333.333 0 0 1-.476 0m-4.476-.291c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534M7.334 6.933a.53.53 0 0 1-.524.534.53.53 0 0 1-.524-.534c0-.294.234-.533.524-.533.289 0 .524.239.524.533"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7.823 7.003a.3.3 0 0 0 .034-.147v-.379a.3.3 0 0 0-.034-.147l-.254-.516a.333.333 0 0 1 .3-.48h.178c.184 0 .334.148.334.333v1.189q0 .076.034.147l.254.517a.333.333 0 0 1-.3.48h-.5a.333.333 0 0 1-.3-.48z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCEU;
